<script>
import {useRoute} from "vue-router";
import {ref} from "vue";
import {useStore} from "vuex";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swal from "sweetalert2";
import {Share} from "@capacitor/share";
import {CallNumber} from "capacitor-call-number";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";

export default {
  name: "StorePage",
  components: {NavbarPage, LoadingPage},
  setup() {

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0


    let store = useStore()

    let loading = ref(false)

    let unit_name = ref(null)
    let unit_phone = ref(null)
    let logo = ref(null)

    let products = ref([])
    let productss = ref([])


    let input_search = ref()

    let unit_id = ref(useRoute().params.unit_id)
    let mark = ref(false)

    let sort = ref(null)

    let data = ref({
      unit_id: unit_id.value,
      sort: null,
    })

    let filter = ref(store.state.filter.product_store)
    if (filter.value != null && filter.value.sort != null){
      data.value = filter.value
      sort.value = data.value.sort
    }


    function load_unit(action , type) {

      if (action){
        data.value.sort = type
        sort.value = type
      }


      loading.value = true

      FreeWorld.Heisenberg(data.value , 'products_unit' , true).then((result) => {

        loading.value = false
        let res = result.data[0]
        unit_name.value = res.unit_name
        unit_phone.value = res.phone
        products.value = res.products
        logo.value = res.unit_logo
        productss.value = res.products
        if (data.value.sort != null){
          store.commit('set_filter_products_store' , data.value)
        }

        if (res.marke == 1) {
          mark.value = true
        }

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result , ()=>{load_unit(action , type)})
      })

    }
    load_unit()

    function mark_unit() {

      let div_mark = document.getElementById('div_mark')

      div_mark.style.pointerEvents = 'none'
      mark.value = !mark.value

      let data = {
        action: 'add',
        item_id: unit_id.value,
        type: 'store',
      }
      FreeWorld.Heisenberg(data , 'user_marke' , true).then((result) => {

        let res = result.data
        setTimeout(() => {
          if (res.event == 'mark delete') {
            mark.value = false
          } else if (res.event == 'mark add') {
            mark.value = true
          }
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

      }).catch(() => {

        setTimeout(() => {
          mark.value = !mark.value
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

        console.log('don`t mark')
      })

    }
    function search_prod() {
      products.value = []
      productss.value.forEach((item) => {
        if (item.name.includes(input_search.value)) {
          products.value.push(item)
        }
      })
    }
    function open_sort_filter() {

      var slide = document.getElementById('slid_filter')
      var background = document.getElementById('alert_background')

      if (slide.style.height != '320px') {

        slide.style.height = '320px'
        background.style.display = 'block'

      } else {

        background.style.display = 'none'
        slide.style.height = 0

      }

    }

    function share_prod() {
      Share.share({
        title: unit_name.value,
        text: 'اپلیکیشن دکوبان',
        url: 'https://decobanapp.ir',
        dialogTitle: 'اشتراک گذاری برای دیگران',
      });
    }

    function call_unit() {
      const userAgent = navigator.userAgent;
      if (userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/)) {
        CallNumber.call({number: unit_phone.value, bypassAppChooser: true});
      } else {
        Swal.fire({
          title: 'شماره پشتیبانی',
          text: unit_phone.value,
          confirmButtonText: 'متوجه شدم',
        })
      }
    }

    return {

      unit_id,
      mark,
      mark_unit,
      loading,
      unit_name,
      products,
      input_search,
      search_prod,
      share_prod,
      unit_phone,
      call_unit,
      open_sort_filter,
      sort,
      load_unit,
      data,
      logo,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div @click="open_sort_filter" id="alert_background" class="alert_background"></div>

  <div :class="loading ? 'activeClass' : '' " id="main" class="bg-main">
    <div class="div-top-holder position-relative">
      <div class="holder_dark w-100 h-100 position-absolute z-3">

      </div>

      <div class="holder_dark position-absolute w-100 h-100">
        <img class="img_store" :src="logo" alt="">
      </div>

      <div class="align-content-start d-flex justify-content-between px-3 py-4 position-relative z-3">
        <div class="d-flex w_costume align-items-center justify-content-between">

          <router-link :to="{name:'StoreInformation' , params:{unit_id:unit_id}}">
            <img class="svg_share" src="../assets/img/informations.svg" alt="">
          </router-link>

          <div id="div_mark" @click="mark_unit">
            <img v-if="mark" class="svg_share" src="../assets/img/save_mark.svg" alt="">
            <img v-else class="svg_share" src="../assets/img/bookmark-white.svg" alt="">
          </div>

          <img @click="share_prod" class="svg_share" src="../assets/img/share.svg" alt="">
          <router-link :to="{name:'CommentProducts',params:{prod_id:unit_id , type:'store'}}">
            <img class="svg_share" src="../assets/img/comment.svg" alt="">
          </router-link>
        </div>
        <div class="d-flex align-items-center">
          <p v-if="unit_name != null" class="animate__animated animate__fadeIn m-0 font-4">{{ unit_name }}</p>
          <div onclick="history.back()">
            <img class="svg-arrow" src="../assets/img/back.svg" alt="">
          </div>
        </div>
      </div>
      <div class="d-flex p-3 z-3 align-items-center w-100 bottom_search justify-content-between flex-row-reverse position-absolute">

        <div @click="open_sort_filter" class="position-relative">
          <div v-if="data.sort != null" class="position-absolute bg-danger font-6 rounded-pill py-1 px-2 text-white">
            <p class="m-0">1</p>
          </div>
          <img style="width: 60px" class="icon_sort" src="../assets/img/sort_icon.svg" alt="">
        </div>

        <div class="div_search w-100">
          <input v-model="input_search" @input="search_prod" class="input_search w-100 text-center bg-white font-4 rounded-pill" type="text" placeholder="به دنبال چه محصولی هستی؟">
        </div>
      </div>
    </div>

    <br>
    <br>
    <br>

    <div class="list_products p-body">


      <div v-if="products.length == 0" class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p class="font-4 ">
            در حال حاضر محصولی وجود ندارد...
          </p>
        </div>
      </div>


      <router-link v-else :to="{name:'DetailsProducts' , params:{sub_cat_id:item.sub_categoris , prod_id:item.id}}" v-for="item in products" :key="item.id"
                   class="animate__animated animate__fadeIn text-decoration-none text-black products_custom d-flex justify-content-between mb-2 shadow-costom p-body">

        <div class="position-relative animated-background rounded-4 div_img_products">

          <img v-if="item.pic1 == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg" alt="">

          <img v-else class="img_products rounded-4" :src="item.pic1" alt="" loading="lazy">

          <div v-if="item.rating_product != null"
               class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

            <img style="width: 20px" src="../assets/img/star_gold.svg" alt="">

            <p class="font-4 mx-1 text-center">{{ item.rating_product }}</p>
          </div>

        </div>


        <div class="information_products overflow-hidden">

          <p class="font-4 font-bold" :class="{'txtoverflow':item.name.length > 26}">{{ item.name }}</p>
          <div class="my-1 d-flex justify-content-start align-items-center my-2">
            <div class="d-flex ml-2 overflow-hidden align-items-center">
              <img style="width: 15px" class="ml-2" src="../assets/img/shop.svg" alt="">
              <div class="overflow-hidden">
                <p class="font-5" :class="{'txtoverflow': unit_name.length > 18}">{{ unit_name }}</p>
              </div>
            </div>
          </div>

          <div class="my-1 d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <img style="width: 15px" src="../assets/img/list.svg" alt="">
              <p class="font-4 mx-2">{{ item.brand }}</p>
            </div>

            <div v-if="item.count == 0" class="existence rounded-pill">
              <p class="font-color font-5 px-2 py-1">
                ناموجود
              </p>
            </div>
          </div>

          <hr>

          <div class="price_div d-flex justify-content-between">
            <div class="d-flex">

              <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-5">
                <span class="">{{ item.price.toLocaleString() }}</span>

                <span v-if="item.off_price == null" class="mx-1">تومان</span>
              </p>


              <p v-if="item.off_price != null" class="font-5 mx-2 font-color m-0">
                <span class="">{{ item.off_price.toLocaleString() }}</span>

                <span class="mx-1">تومان</span>
              </p>

            </div>


            <p v-if="item.off_price != null" class="off_percent font-5 rounded-pill font-color">
              <span>%</span>
              <span>{{ item.discount }}</span>
            </p>
          </div>
        </div>

      </router-link>

    </div>

    <br>

    <div id="slid_filter" class="slid_filter p-body bg-white border-costom shadow-costom">

      <div @click="open_sort_filter" class="hr_top_filter_slider rounded-pill my-3 m-auto"></div>

      <p class="font-3 text-center font-bold">
        مرتب سازی بر اساس :
      </p>
      <hr>
      <p @click="load_unit('sort' , null)" :class="sort == null ? 'font-color' : '' " class="font-4 text-center py-1">
        همه
      </p>
      <hr>
      <p @click="load_unit('sort' , 'sell')" :class="sort == 'sell' ? 'font-color' : '' "
         class="font-4 text-center py-1">
        پرفروش ترین
      </p>
      <hr>
      <p @click="load_unit('sort' , 'discount')" :class="sort == 'discount' ? 'font-color' : '' "
         class="font-4 text-center py-1">
        پرتخفیف ترین
      </p>
      <hr>
      <p @click="load_unit('sort' , 'Visit')" :class="sort == 'Visit' ? 'font-color' : '' " class="font-4 text-center py-1">
        پربازدید ترین
      </p>

    </div>


  </div>

  <div :class="loading ? 'activeClass' : '' " id="web" class="bg-main">
    <NavbarPage></NavbarPage>

    <div class="div-top-holder-web position-relative">
      <div class="holder_dark w-100 h-100 position-absolute z-3">

      </div>

      <div class="holder_dark position-absolute w-100 h-100">
        <img class="img_store" :src="logo" alt="">
      </div>

      <div class="align-content-start d-flex justify-content-between px-3 py-4 position-relative z-3">
        <div class="d-flex w_costume align-items-center justify-content-evenly">

          <router-link :to="{name:'StoreInformation' , params:{unit_id:unit_id}}">
            <img style="width: 25px" class="" src="../assets/img/informations.svg" alt="">
          </router-link>

          <div id="div_mark" @click="mark_unit">
            <img style="width: 25px" v-if="mark" class="" src="../assets/img/save_mark_web.svg" alt="">
            <img style="width: 25px" v-else class="" src="../assets/img/bookmark-white.svg" alt="">
          </div>

          <img @click="share_prod" style="width: 25px" src="../assets/img/share.svg" alt="">

          <router-link :to="{name:'CommentProducts',params:{prod_id:unit_id , type:'store'}}">
            <img style="width: 25px" class="" src="../assets/img/comment.svg" alt="">
          </router-link>
        </div>
        <div class="d-flex align-items-center">
          <h4 v-if="unit_name != null" class="animate__animated animate__fadeIn m-0 mr-10">{{ unit_name }}</h4>
        </div>
      </div>

      <div class="d-flex p-3 z-3 align-items-center w-50 center-x bottom_search justify-content-between flex-row-reverse position-absolute">
        <div class="div_search w-100">
          <input v-model="input_search" @input="search_prod" class="input_search w-100 text-center bg-white font-4 rounded-pill" type="text" placeholder="به دنبال چه محصولی هستی؟">
        </div>
      </div>
    </div>

    <br>
    <br>

    <div class="list_products-web p-body">
      <div id="slid_filter-web" class="slid_filter-web rounded-4 p-body bg-white border-costom shadow-costom position-relative">
        <p class="font-3 text-center font-bold mt-3">
          مرتب سازی بر اساس :
        </p>
        <div class="center-y w-80">
        <p @click="load_unit('sort' , null)" :class="sort == null ? 'font-color' : '' " class="item_slid_filter-web rounded-pill font-4 text-center py-1">
          همه
        </p>
        <hr>
        <p @click="load_unit('sort' , 'sell')" :class="sort == 'sell' ? 'font-color' : '' " class="item_slid_filter-web rounded-pill font-3 text-center py-1">
          پرفروش ترین
        </p>
        <hr>
        <p @click="load_unit('sort' , 'discount')" :class="sort == 'discount' ? 'font-color' : '' " class="item_slid_filter-web rounded-pill font-3 text-center py-1">
          پرتخفیف ترین
        </p>
        <hr>
        <p @click="load_unit('sort' , 'Visit')" :class="sort == 'Visit' ? 'font-color' : '' " class="item_slid_filter-web rounded-pill font-3 text-center py-1">
          پربازدید ترین
        </p>
        </div>
      </div>

      <div style="width: calc(100% - 21rem)" class="overflow-y-scroll align-content-start d-flex flex-wrap justify-content-between">
        <div v-if="products.length == 0" class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
             style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
            <br>
            <p class="font-4 ">
              در حال حاضر محصولی وجود ندارد...
            </p>
          </div>
        </div>

        <router-link :to="{name:'DetailsProducts' , params:{sub_cat_id:item.sub_categoris , prod_id:item.id}}" v-for="item in products" :key="item.id"
                     class="animate__animated animate__fadeIn mx-1 rounded-shaped text-decoration-none text-black products_custom-web d-flex justify-content-between mb-2 shadow-costom p-body">

          <div style="width: 10rem;height: 10rem" class="position-relative animated-background rounded-4">

            <img v-if="item.pic1 == null " class="rounded-4 w-100 h-100" src="../assets/img/img-notavalible.jpg" alt="">

            <img v-else class="rounded-4 w-100 h-100" :src="item.pic1" alt="">

            <div v-if="item.rating_product != null"
                 class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

              <img style="width: 1.2rem" src="../assets/img/star_gold.svg" alt="">

              <p class="font-4 mx-1 text-center">{{ item.rating_product }}</p>
            </div>

          </div>

          <div style="width: calc(100% - 10.5rem)" class="information_products overflow-hidden">
            <p class="font-4 font-bold" :class="{'txtoverflow':item.name.length > 26}">{{ item.name }}</p>
            <div class="my-1 d-flex justify-content-start align-items-center my-2">
              <div class="d-flex ml-2 overflow-hidden align-items-center">
                <img style="width: 15px" class="ml-2" src="../assets/img/shop.svg" alt="">
                <div class="overflow-hidden">
                  <p class="font-5" :class="{'txtoverflow': unit_name.length > 18}">{{ unit_name }}</p>
                </div>
              </div>
            </div>

            <div class="my-1 d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <img style="width: 15px" src="../assets/img/list.svg" alt="">
                <p class="font-4 mx-2">{{ item.brand }}</p>
              </div>

              <div v-if="item.count == 0" class="existence rounded-pill">
                <p class="font-color font-5 px-2 py-1">
                  ناموجود
                </p>
              </div>
            </div>

            <hr>

            <div class="price_div d-flex justify-content-between">
              <div class="d-flex">

                <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-5">
                  <span class="">{{ item.price.toLocaleString() }}</span>

                  <span v-if="item.off_price == null" class="mx-1">تومان</span>
                </p>


                <p v-if="item.off_price != null" class="font-5 mx-2 font-color m-0">
                  <span class="">{{ item.off_price.toLocaleString() }}</span>

                  <span class="mx-1">تومان</span>
                </p>

              </div>


              <p v-if="item.off_price != null" class="off_percent font-5 rounded-pill font-color">
                <span>%</span>
                <span>{{ item.discount }}</span>
              </p>
            </div>
          </div>

        </router-link>
      </div>
    </div>

    <br>

  </div>

</template>

<style scoped>

.div-top-holder {
  direction: ltr;
  height: 165px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  max-width: 700px;
  color: white;
  align-items: center;
  justify-content: end;
  background-color: rgba(101, 101, 101, 0.24);
}
.svg_share {
  width: 20px;
}
.w_costume {
  width: 40%;
}
.input_search {
  height: 60px;
  border: 1px solid #8C8C8CA0;
}
.bottom_search {
  bottom: -50px;
}
.img_store {
  width: 100%;
  height: 100%;
  object-fit: cover !important;
}
.holder_dark {
  backdrop-filter: brightness(0.5);
}
.div_hr {
  width: 2px;
  height: 45px;
  background-color: rgba(255, 255, 255, 0.6);
}
.products_custom {
  padding: 12px 7px 12px 7px;
  border-radius: 15px;
  width: 100%;
  background-color: white;
}
.img_products {
  width: 100%;
  height: 100%;
}
p {
  margin: 0;
}
.div_stars {
  left: 50%;
  transform: translate(-50%);
  bottom: -8%;
  background-color: white;
  justify-content: center;
}
.off_percent {
  padding: 5px;
  text-align: center;
  background-color: #d2d2d2;
}
.number_star {
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
}
.div_img_products {
  width: 9rem;
  height: 9rem;
  margin-bottom: 5px
}
.information_products {
  direction: rtl;
  width: calc(100% - 9.5rem);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.existence {
  border: 1px solid #8C8C8CA0;
  background-color: #d2d2d2;
}
.list_products::-webkit-scrollbar {
  display: none;
}
.alert_background {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(79, 78, 78, 0.44);
  display: none;
  max-width: 500px;
  z-index: 2;
}
.slid_filter {
  width: 100%;
  height: 0;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  position: fixed;
  bottom: 0;
  z-index: 5;
  max-width: 500px;
  padding-left: 100px;
  padding-right: 100px;
  overflow: hidden;
  transition: 0.5s;
}
.hr_top_filter_slider {
  width: 80%;
  height: 7px;
  background-color: rgba(255, 111, 0, 0.50);
}


.div_img_products-web {
  width: 35%;
  height: 11rem;
  margin-bottom: 5px
}
.products_custom-web {
  padding: 1rem;
  height: fit-content;
  flex-grow: 1;
  min-width: 47%;
  background-color: white;
}
.div-top-holder-web {
  direction: ltr;
  height: 400px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  color: white;
  align-items: center;
  justify-content: end;
  background-color: rgba(101, 101, 101, 0.24);
}
.slid_filter-web {
  width: 20rem;
  height: 100%;
  z-index: 5;
  max-width: 23rem;
  min-width: 15rem;
  padding: 0 2rem;
  overflow: hidden;
  transition: 0.5s;
}
.list_products-web{
  display: flex;
  justify-content: space-between;
  height: 30rem;
}
.item_slid_filter-web{
  transition: .5s;
}
.item_slid_filter-web:hover{
  background-color: #818285;
  color: white !important;
  outline: 1px solid #e15900;
}

</style>